module.exports = __webpack_public_path__ + "c0efb208fdb9edfc6df12b5ad96c9d8b.MP3";